import React from 'react';
import { graphql } from 'react-relay';

import withData from '@zego/lib/withData';

import PromotionsLayout from './PromotionsLayout';

export default function withPromotionsLayout(Component, layoutProps) {
  const Wrapped = ({ viewer, ...props }) => {
    return (
      <PromotionsLayout viewer={viewer} {...layoutProps}>
        <Component {...props} viewer={viewer} />
      </PromotionsLayout>
    );
  };

  return withData(Wrapped, {
    query: graphql`
      query withPromotionsLayoutQuery($country: String!) {
        viewer {
          ...PromotionsLayout_viewer
          country: countryByCode(code: $country) {
            salesNumber
          }
        }
      }
    `,
    getVariables: () => {
      return {
        country: 'gb',
      };
    },
  });
}
